import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAtomValue, useSetAtom } from "jotai";
import { Link, useNavigate } from "react-router-dom";
import { Activity, Settings } from "lucide-react";
import { currentUserAtom } from "../atoms/authAtom";
import { authApi } from "../service/authApi";
import { ThemeToggle } from "./ThemeToggle";
import styles from "./Header.module.scss";
export function Header() {
    const user = useAtomValue(currentUserAtom);
    const setCurrentUser = useSetAtom(currentUserAtom);
    const navigate = useNavigate();
    async function handleLogout() {
        await authApi.logout();
        setCurrentUser(null);
        navigate("/login");
    }
    return (_jsxs("header", { className: styles.header, children: [_jsx(Link, { to: "/", className: styles.brand, children: "Sentinel" }), _jsxs("div", { className: styles.userArea, children: [_jsx(ThemeToggle, {}), user && (_jsxs(_Fragment, { children: [user.roles.includes("Admin") && (_jsx("a", { href: "/hangfire", rel: "noopener noreferrer", className: styles.iconLink, title: "Hangfire dashboard", "aria-label": "Hangfire dashboard", children: _jsx(Activity, { size: 18 }) })), _jsx(Link, { to: "/settings/komodo", className: styles.iconLink, title: "Komodo-integration", "aria-label": "Inst\u00E4llningar", children: _jsx(Settings, { size: 18 }) }), _jsx(Link, { to: "/account", children: user.displayName }), _jsx("button", { type: "button", onClick: handleLogout, className: styles.logout, children: "Logga ut" })] }))] })] }));
}
